module.exports = __webpack_public_path__ + "static/media/paw.b568c8d6.svg";